import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { IBannerPromotion } from '~/data/types/car/cars';
import ResultsPageBannerPromotion from '../ResultsPageBannerPromotion';
import useStyles from './useStyles';

interface IBannersPromotionProps {
  bannersPromotion: IBannerPromotion[] | null;
  close: (shouldClose: boolean) => void;
}

const BannersPromotion: React.FC<IBannersPromotionProps> = ({
  bannersPromotion,
  close,
}) => {
  const classes = useStyles();
  const [activeIndex, setActiveIndex] = useState(0);
  const activeDots = bannersPromotion && bannersPromotion?.length > 1;

  useEffect(() => {
    if (activeDots) {
      const interval = setInterval(() => {
        setActiveIndex((prevIndex) =>
          prevIndex === bannersPromotion.length - 1 ? 0 : prevIndex + 1,
        );
      }, 8000);
      return () => clearInterval(interval);
    }
  }, [bannersPromotion?.length, activeDots]);

  return (
    <Box sx={classes.container}>
      {bannersPromotion && bannersPromotion?.length > 0 && (
        <Box key={activeIndex}>
          <ResultsPageBannerPromotion
            bannerPromotion={bannersPromotion[activeIndex]}
            close={close}
            showCloseButton={false}
          />
        </Box>
      )}

      {activeDots && (
        <Box sx={classes.dotsContainer}>
          {bannersPromotion.map((_, index) => (
            <Box
              key={index}
              sx={{
                ...classes.dot,
                ...(index === activeIndex
                  ? classes.activeDot
                  : classes.inactiveDot),
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default BannersPromotion;
